import React from 'react';
import './style.scss'

const Footer = () => {
    return (
        <footer>
            <div className="container">
                <div className="outer__footer">
                    <div className="footer-top-row">
                        <div className="footer-brand-block">
                            <a href="https://pandaonwheels.com/" className="footer-brand-wordmark">
                                <span className="brand-badge" role="img" aria-label="panda">🐼</span>
                                <span className="brand-text">
                                  Panda<span className="brand-text--accent">On</span>Wheels
                                </span>
                            </a>
                            <p className="footer-tagline">
                                <span>FAST</span>
                                <span className="dot">•</span>
                                <span>FRESH</span>
                                <span className="dot">•</span>
                                <span>DELICIOUS</span>
                            </p>
                            <p className="footer-description">
                                Delivering your favorite authentic restaurant dishes fast, fresh, and with a joyful smile.
                            </p>
                        </div>
                        <div className="footer-right">
                            <ul className="footer-nav">
                                <li><a href="https://pandaonwheels.com/">Browse Restaurants</a></li>
                                <li><a href="https://pandaonwheels.com/">About Panda</a></li>
                                <li><a href="https://pandaonwheels.com/">FAQ &amp; Support</a></li>
                                <li><a href="https://pandaonwheels.com/">Office Catering</a></li>
                            </ul>
                            <a href="https://pandaonwheels.com/" className="need-help-btn">
                                <span role="img" aria-hidden="true">🎧</span> Need help?
                            </a>
                        </div>
                    </div>
                    <div className="bottom__footer">
                        <div className="bottom__left">
                            <a href="https://pandaonwheels.com/" className="footer-brand-wordmark">
                                <span className="brand-badge" role="img" aria-label="panda">🐼</span>
                                <span className="brand-text">
                                  Panda<span className="brand-text--accent">On</span>Wheels
                                </span>
                            </a>
                        </div>
												<div className="bottom__center">
													<p>© {new Date().getFullYear()} Panda On Wheels. All rights reserved.</p>
												</div>
                        <div className="bottom__right">
                            <ul>
                                <li><a href="https://pandaonwheels.com/"><i className="fab fa-facebook-f"></i></a></li>
                                <li><a href="https://pandaonwheels.com/"><i className="fab fa-twitter"></i></a></li>
                                <li><a href="https://pandaonwheels.com/"><i className="fab fa-pinterest-p"></i></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}
export default Footer
